import { Box, styled } from '@mui/material';
import { PollRecord } from '../../../../models/Poll';

interface OptionPercentageProps {
    poll: PollRecord;
    option: 1 | 2;
}

const OptionPercentage = (props: OptionPercentageProps): JSX.Element => {
    const right = props.option === 2;
    const totalVotes =
        props.poll.options[0].votes + props.poll.options[1].votes;
    const rndPct = Math.round(
        (props.poll.options[props.option - 1].votes / totalVotes) * 100,
    );
    const winner =
        props.poll.options[props.option - 1].votes >
        props.poll.options[props.option - 1 ? 0 : 1].votes;
    const classes =
        'poll-option-percentage' +
        (winner ? ' winner' : '') +
        (!right ? ' align-right' : ' text-align-right');

    const SizedBox = styled(Box)({
        width: `${rndPct}%`,
        minWidth: '2.5rem',
    });

    return <SizedBox className={classes}>{`${rndPct}%`}</SizedBox>;
};

export default OptionPercentage;
